import { Component, Input } from '@angular/core';
import { Question } from '../../models/flow.dto';

@Component({
    selector: 'help-text',
    templateUrl: './help-text.component.html',
    styleUrls: ['./help-text.component.scss'],
    standalone: false
})
export class HelpTextComponent {
    @Input() alert: boolean = false;
    @Input() helpText: string;
    @Input() question: Question;
    @Input() position: string = 'top';

    get text(): string {
        if (this.question != null && this.question.helpText != null) return this.question.helpText;
        return this.helpText;
    }
}